// Snippet to trigger a tab switch via a link (that is not a tab button).
// This is assuming that the tabs are using Twitter Bootstrap's tabs JS.
// See: http://stackoverflow.com/questions/19625211/bootstrap-linking-to-a-tab-with-an-url
$(document).on('click', '.js-tab-open', function(e) {
  e.preventDefault();
  var anchor = $(this).attr('href');
  $('a[data-toggle="tab"][href="' + anchor + '"]').tab('show');
});
